//
//  config/townlitDistribution.ts
//  TownLIT
//
//  Created by Hossein Sakkaki on 2026-08-19.
//  Last Update by Hossein Sakkaki on 2026-08-19. 
//

export type TownLITClientPlatform =
  | "unknown"
  | "ios"
  | "android"
  | "desktop"
  | "other";

export type TownLITDistributionChannel =
  | "app-store"
  | "pwa"
  | "web";

export const TOWNLIT_APP_STORE = {
  appId: "6779987067",
  url: "https://apps.apple.com/us/app/townlit/id6779987067",
  badgeSrc: "/images/badges/download-on-the-app-store.svg",
} as const;

export const TOWNLIT_ROUTES = {
  app: "/app",
  webHome: "/",
  legacyInstallApp: "/townlit-official/install-app",
} as const;

export const TOWNLIT_DISTRIBUTION: Record<
  TownLITClientPlatform,
  TownLITDistributionChannel
> = {
  unknown: "web",
  ios: "app-store",
  android: "pwa",
  desktop: "web",
  other: "web",
};

export const TOWNLIT_PWA_PROMPT = {
  dismissStorageKey: "townlit:pwa-install-prompt:dismissed-at",
  dismissCooldownMs: 7 * 24 * 60 * 60 * 1000,
} as const;

export function getTownLITDistributionChannel(
  platform: TownLITClientPlatform,
): TownLITDistributionChannel {
  return TOWNLIT_DISTRIBUTION[platform];
}

export function shouldOfferTownLITPWA(
  platform: TownLITClientPlatform,
): boolean {
  return getTownLITDistributionChannel(platform) === "pwa";
}